<!--================= Header Section Start Here =================-->
<app-header></app-header>
<!--================= Header Section End Here =================-->
<section class="user-dashboard-section section-b-space">
    <div class="container-fluid-lg">
        <div class="row">
            <!--================= Header Section Start Here =================-->
            <div class="col-xxl-3 col-lg-4">
                <app-sitebar></app-sitebar>
            </div>
            <!--================= Header Section End Here =================-->

            <!--= ================ Wrapper Start Here =================-->
            <div class="col-xxl-9 col-lg-8">
                <router-outlet>
                </router-outlet>
            </div>

            <!--================= Wrapper End Here =================-->
        </div>
    </div>
</section>
<!--================= Footer Section Start Here =================-->
<app-footer></app-footer>
<!--================= Footer Section End Here =================-->